import map from 'lodash/map'
import sortBy from 'lodash/sortBy'
import * as React from 'react'

import PanelListSorter from '@frontrow/console/src/components/common/panel-list/panel-list-sorter'
import PanelListContent from '@frontrow/console/src/components/common/panel-list/panel-list-content'
import * as styles from './panel-list.module.scss'

type PanelListSortersT<T> = {
  label: string
  sortMethod: (data: T) => number | string
}

type Props<T> = {
  dataList: Array<T>
  renderListElement: (data: T, index: number) => React.ReactElement
  sorters?: Array<PanelListSortersT<T>>
  /** Fills the card's header band when the list has no sorters, e.g. with
   * column headings for the rows below. */
  header?: React.ReactNode
}

export default function PanelListContainer<T>(props: Props<T>): React.ReactElement {
  const {sorters, dataList, renderListElement, header} = props
  const [sorterIndex, setSorterIndex] = React.useState<number | undefined | null>(null)

  const sortBySorter = (newSorterIndex: number) => {
    setSorterIndex(newSorterIndex)
  }

  const sortingHeader =
    sorters !== undefined && sorters !== null && sorters.length > 0 ? (
      <PanelListSorter
        description="Sort By"
        defaultIndex={0}
        radioLabels={map(sorters, sorter => sorter.label)}
        sortBySorter={sortBySorter}
      />
    ) : null

  const processedData =
    sorterIndex !== undefined &&
    sorterIndex !== null &&
    sorters !== undefined &&
    sorters !== null &&
    sorters.length > 0
      ? sortBy(dataList, sorters[sorterIndex].sortMethod)
      : dataList

  // Without this the band still renders its padding, fill and border with
  // nothing in it, which is what the teacher and school licenses pages showed.
  const headerContent = sortingHeader ?? header ?? null

  return (
    <div className={styles.panelListCard}>
      {headerContent !== null ? (
        <div className={styles.panelListCardHeader}>{headerContent}</div>
      ) : null}
      <PanelListContent dataList={processedData} renderListElement={renderListElement} />
    </div>
  )
}
